import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHero } from "./Services";

export default function Portfolio() {
  const { data: items } = useQuery({ queryKey: ["portfolio"], queryFn: () => api.get("/portfolio").then(r => r.data.items) });
  return (
    <div>
      <PageHero label="Portfolio" title="Work we're proud of" subtitle="A look at websites and automation projects we've delivered for local businesses." />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {(items || []).map((p) => (
          <div key={p.id} data-testid={`portfolio-${p.id}`} className="rounded-xl border border-slate-200 overflow-hidden hover:shadow-lg transition-all">
            {p.images?.[0] && <div className="aspect-video bg-slate-100 overflow-hidden"><img src={p.images[0]} alt={p.title} className="w-full h-full object-cover" /></div>}
            <div className="p-5">
              <span className="text-[10px] font-mono uppercase tracking-wider text-electric">{p.serviceType}</span>
              <h3 className="mt-1 font-heading font-semibold text-navy">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-600">{p.description}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
